import React from 'react';

const FALLBACK_DESCRIPTIONS = {
  'AI Insights':
    'Smart summaries, anomaly detection, and trading insights powered by FlowQuant AI. Get personalized risk alerts, performance summaries, and journaling suggestions built around your workflow.',
  'Broker Integrations':
    'Connect supported brokers like Alpaca, Binance, and Robinhood to auto-import trades and reduce manual entry, making FlowQuant a more connected trading workspace.',
  'Advanced Analytics':
    'Dive deeper into your trading performance with expanded metrics, behavior trends, and more advanced visual breakdowns designed to sharpen decision-making.',
  'Strategy Lab':
    'Design, test, and refine trading strategies with customizable rule sets, scenario thinking, and structured performance tracking built for serious traders.',
};

export default function ComingSoon({
  eyebrow = 'FLOWQUANT PREMIUM',
  title,
  description,
}) {
  const resolvedDescription = description || FALLBACK_DESCRIPTIONS[title] || '';

  return (
    <div className="p-6 text-white">
      <div className="mx-auto max-w-4xl rounded-2xl border border-white/10 bg-[#171717] p-8 text-center shadow-lg">
        <p className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-3">
          {eyebrow}
        </p>

        <h2 className="text-2xl font-semibold mb-4">{title}</h2>

        {resolvedDescription ? (
          <p className="text-sm md:text-base text-gray-400 max-w-2xl mx-auto leading-8">
            {resolvedDescription}
          </p>
        ) : null}
      </div>
    </div>
  );
}